// extracted by mini-css-extract-plugin
export default {"boss":"BossUI_boss__Ev3Vm"};